module.exports = __webpack_public_path__ + "static/media/KUDOS TITAN 808 SPEAKERS.f1883022.png";